import { createActionGroup, emptyProps, props } from '@ngrx/store';

import {
  ServiceExportDto,
  ServiceListItemDto,
  ServiceSearchPayload,
  ServiceSlaUpdatePayload,
  ServiceStatsDto,
  ServiceStatusPayload,
  ServiceReadDto,
  ServiceUpsertPayload,
} from '../models/service-management-api';

export const ServiceManagementActions = createActionGroup({
  source: 'Service Management',
  events: {
    'Load List': props<{ query: ServiceSearchPayload }>(),
    'Load List Success': props<{
      rows: ServiceListItemDto[];
      total: number;
      page: number;
      pageSize: number;
      stats: ServiceStatsDto;
    }>(),
    'Load List Failure': props<{ error: string }>(),
    'Load Service': props<{ serviceId: string; mode: 'view' | 'edit' }>(),
    'Load Service Success': props<{ service: ServiceReadDto; mode: 'view' | 'edit' }>(),
    'Load Service Failure': props<{ error: string }>(),
    'Create Service': props<{ payload: ServiceUpsertPayload }>(),
    'Update Service': props<{ serviceId: string; payload: ServiceUpsertPayload }>(),
    'Persist Success': props<{ message: string; service: ServiceReadDto }>(),
    'Persist Failure': props<{ error: string }>(),
    'Update Service Status': props<{ serviceId: string; payload: ServiceStatusPayload }>(),
    'Update Service Status Success': props<{ message: string; service: ServiceReadDto }>(),
    'Update Service Status Failure': props<{ error: string }>(),
    'Update Service Sla': props<{ serviceId: string; payload: ServiceSlaUpdatePayload }>(),
    'Update Service Sla Success': props<{ message: string; service: ServiceReadDto }>(),
    'Update Service Sla Failure': props<{ error: string }>(),
    'Export Services': props<{
      query: Pick<ServiceSearchPayload, 'search' | 'statuses' | 'reworkStatuses'>;
    }>(),
    'Export Services Success': props<{ response: ServiceExportDto }>(),
    'Export Services Failure': props<{ error: string }>(),
    'Clear Error': emptyProps(),
    'Clear Success Message': emptyProps(),
  },
});
